"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.spin = void 0;
var _core = require("@emotion/core");
const spinKeyframes = (0, _core.keyframes)`
100% {
  transform:rotate(360deg);
}
`;
const spin = () => (0, _core.css)`
  animation: ${spinKeyframes} 2s linear infinite;
`;
exports.spin = spin;